import { orderXClient } from '@/service/client'
import type {
  DataPayload,
  OrderbookHeatmap,
  OrderbookHeatmapRequest,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

/**
 * Order-book liquidity heatmap pull endpoint (read-only, request/reply). Each
 * column is one snapshot of the book within ±25% of mid, bucketed on its own
 * price grid — see the `OrderbookHeatmapColumn` doc in public_api.proto.
 */
export async function fetchOrderbookHeatmap(
  params: OrderbookHeatmapRequest,
  signal?: AbortSignal
): Promise<OrderbookHeatmap> {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { orderbookHeatmap: params },
      { headers: { 'X-Decode-Key': 'datapayload' }, signal }
    )

    const heatmap = data.orderbookHeatmap
    if (!heatmap) {
      return Promise.reject({
        status: 400,
        message: 'Response did not include the orderbook_heatmap payload.',
      } satisfies ErrorResponse)
    }
    return heatmap
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
